import React from 'react';
import { Loader, BaasicTable, BaasicHeader } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const CarrierListTemplate = ({ viewStore, viewStore: { loading, listStore, tableData, queryUtility } }) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<BaasicHeader title="MAINMENU.ADMINISTRATION.SHIPPINGCARRIERS"></BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					viewStore,
				}}
				data={listStore.data.slice()}
				actions={viewStore}
			/>
		</React.Fragment>
	);
};

export default defaultTemplate(CarrierListTemplate);
